import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { Link } from "react-router-dom";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";

const ListMedia = ({ listings, classes, page }) => {
  const formatDate = (dateString) => new Date(dateString).getUTCFullYear();

  const getCategoryName = (id) => {
    if (classes?.length > 0) {
      const cat = classes.find((c) => c.id === id);
      return cat?.name || "";
    }
    return "";
  };

  const cols = page === "Home"
    ? { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(3, 1fr)" }
    : { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(5, 1fr)" };

  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: cols,
        mt: 2,
      }}
    >
      {listings.map((list) => (
        <Box
          key={list.id}
          component={Link}
          to={"/listing/" + list.id}
          sx={{ textDecoration: "none", display: "block" }}
        >
          <Box
            sx={{
              backgroundColor: "#1a1a1a",
              border: "1px solid #2a2a2a",
              borderRadius: "12px",
              overflow: "hidden",
              cursor: "pointer",
              transition: "all 0.25s ease",
              "&:hover": {
                border: "1px solid #FFC001",
                transform: "translateY(-2px)",
                "& .card-name": { color: "#FFC001" },
              },
            }}
          >
            {/* Image */}
            <Box sx={{ position: "relative", height: "160px", overflow: "hidden" }}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url(${list.media?.[0]?.url})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "scale(1.05)" },
                }}
              />

              {/* Price badge */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: 8,
                  backgroundColor: "rgba(255,192,1,0.92)",
                  color: "#000",
                  fontWeight: 800,
                  fontSize: "13px",
                  px: 1.2,
                  py: 0.3,
                  borderRadius: "20px",
                  backdropFilter: "blur(4px)",
                }}
              >
                ${list.price}
              </Box>

              {/* Status chips */}
              {(list.on_hold || list.status === "sold" || list.status === "nfs") && (
                <Box sx={{ position: "absolute", top: 8, left: 8 }}>
                  {list.on_hold ? (
                    <Chip label="HOLD" size="small" sx={{ backgroundColor: "#FFD300", color: "#000", fontWeight: 700, fontSize: "10px", height: "18px" }} />
                  ) : list.status === "sold" ? (
                    <Chip label="SOLD" size="small" sx={{ backgroundColor: "#EF0107", color: "#fff", fontWeight: 700, fontSize: "10px", height: "18px" }} />
                  ) : (
                    <Chip label="NFS" size="small" sx={{ backgroundColor: "#333", color: "#aaa", fontWeight: 700, fontSize: "10px", height: "18px" }} />
                  )}
                </Box>
              )}

              {/* Sex icon */}
              <Box sx={{ position: "absolute", top: 8, right: 8 }}>
                {list.sex === "male" ? (
                  <MaleIcon sx={{ color: "#4da6ff", fontSize: 16 }} />
                ) : list.sex === "female" ? (
                  <FemaleIcon sx={{ color: "#ff69b4", fontSize: 16 }} />
                ) : (
                  <Box sx={{ display: "flex" }}>
                    <MaleIcon sx={{ color: "#4da6ff", fontSize: 14 }} />
                    <FemaleIcon sx={{ color: "#ff69b4", fontSize: 14 }} />
                  </Box>
                )}
              </Box>
            </Box>

            {/* Info */}
            <Box sx={{ p: 1.5 }}>
              <Typography
                className="card-name"
                noWrap
                sx={{ color: "#fff", fontWeight: 700, fontSize: "14px", transition: "color 0.2s" }}
              >
                {list.name}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0.5 }}>
                <Typography noWrap sx={{ color: "#666", fontSize: "12px" }}>
                  {getCategoryName(list.category_id)}
                </Typography>
                <Typography sx={{ color: "#444", fontSize: "11px" }}>
                  {formatDate(list.created_at)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ListMedia;
